import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manualType: "",
};

export const manualTypeSlice = createSlice({
  name: "manualTypeChecker",
  initialState,
  reducers: {
    setManualTypeReducer: (state, action) => {
      state.manualType = action.payload.manualType;
    },
  },
});

export const { setManualTypeReducer } = manualTypeSlice.actions;

export default manualTypeSlice.reducer;
